
import { Component, Vue } from "vue-property-decorator";
import NavigationMenu from "@/components/NavigationMenu.vue";

@Component({
  components: {
    NavigationMenu,
  },
  methods: {
    scrollToTop(): void {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
})
export default class extends Vue {}
